
import { renderHTML } from '@app/vue/Utils/editorjs-viewer';

export default {
    props: {
        description: {
            type: String,
        },
    },
    watch: {
        editorConvertHTML: {
            immediate: true,
            handler: function (newVal, oldVal) {
                setTimeout(() => {
                    this.textHeight = this.$refs.descriptionText?.clientHeight;
                }, 100);
            },
            deep: true
        }
    },
    methods: {
        onViewText() {
            this.viewText = !this.viewText;
            const text = document.querySelector('.dt__listPage-description');

            if (this.viewText) {
                text.classList.remove('dt__listPage-description-max');
            } else {
                text.classList.add('dt__listPage-description-max');
            }
        },
    },
    mounted() {
        const data = JSON.parse(this.description);
        this.editorConvertHTML = renderHTML(data.blocks);
    },
    data() {
        return {
            textHeight: 0,
            viewText: false,
            editorConvertHTML: '',
        };
    }
}
